<template>
  <header>
    <div class="s">
      <button @click.prevent="showNav()" class="menu-btn-s"></button>

      <div :style="styleNavLg" class="overlay">
        <div class="box-btn">
          <img src="../../assets/images/admans_logo.png">
          <button @click.prevent="closeNav()" class="close-btn"></button>
        </div>
        <nav class="box-link">
          <div
            v-for="(menu, i) in menus"
            :key="i"
            :class="[menu.active ? 'router-link-exact-active' : '']"
            class="section-link"
          >
            <!-- <router-link :to="menu.route">
              {{ menu.title }}
            </router-link> -->
            <div
              @click="showSubArchives = !showSubArchives"
              v-if="menu.title.toLowerCase() === 'archives'"
              :style="showSubArchives ? { height: '100%' } : {}"
            >
              <span>Archives</span>
              <div
                class="sub-archive-small"
                :class="showSubArchives ? 'sub-archive-small--open' : ''"
              >
                <router-link
                  v-for="(sub, subIndex) in menu.subs"
                  :key="subIndex"
                  :to="{ name: sub.routeName }"
                >
                  {{ sub.title }}
                </router-link>
              </div>
            </div>

            <router-link
              v-else
              :to="menu.route"
            >
              {{ menu.title }}
            </router-link>
          </div>
        </nav>
      </div>
    </div>

    <div class="m">
      <b-container class="first">
        <nav class="left">
          <div
            v-for="(menu, i) in menus"
            :key="i"
            :to="menu.route"
            class="section"
            :class="[menu.active ? 'router-link-exact-active' : '']"
          >
            <!-- <router-link :to="menu.route">
              {{ menu.title }}
            </router-link> -->
            <div
              @click="showSubArchives = !showSubArchives"
              v-if="menu.title.toLowerCase() === 'archives'"
              style="cursor: pointer;width:100%;height:100%;"
              :style="showSubArchives ? { background: '#DA0401' } : {}"
            >
              <span :style="showSubArchives ? { color: '#F1F2F2' } : {}">Archives</span>
              <div
                v-if="showSubArchives"
                @mouseleave="showSubArchives = false"
                class="sub-archive-medium"
                :class="showSubArchives ? '' : ''"
              >
                <router-link
                  v-for="(sub, subIndex) in menu.subs"
                  :key="subIndex"
                  :to="{ name: sub.routeName }"
                  style="border-top:0"
                >
                  {{ sub.title }}
                </router-link>
              </div>
            </div>

            <router-link
              v-else
              :to="menu.route"
            >
              {{ menu.title }}
            </router-link>
          </div>
        </nav>
      </b-container>
      <!-- Nomarl -->
      <div v-if="false" class="right">
        <div class="box-search">
          <input type="text" placeholder="Search">
          <button></button>
        </div>
        <div class="box-icon">
          <img src="../../assets/images/user-icon.png">
        </div>
        <div class="user-btn">
          <button @click="clickLogin()">USER LOGIN</button>
        </div>
      </div>

      <!-- Calendar -->
      <div v-if="isCalendar" class="right box-calendar">
        <div class="box-search">
          <p>Creativity Day 2019</p>
        </div>

        <div class="box-icon">
          <img src="../../assets/icons/ic-calendar.png">
          <p>06 November 2019</p>
        </div>

        <div title="Add to Calendar" class="addeventatc add-calendar">
          <span class="client">abKiFTOwhzsuRNYVAmhK73953</span>
          <div>Add to Calendar</div>
            <span class="start">06-11-2019 09:00</span>
            <span class="end">06-11-2019 22:00</span>
            <span class="title">Creativity Day 2019</span>
            <span class="description">“วันความคิดสร้างสรรค์แห่งชาติ 2019”
ช่วงเช้าถึงเย็น รูปแบบงานคืองาน Talks, School of Creativity & Exhibition ซึ่งเป็นงานของคนไทยทุกคน ที่เห็นคุณค่าของความคิดสร้างสรรค์ และช่วงค่ำจะมีกิจกรรมพิเศษของคนในวงการโฆษณาและผู้มีส่วนเกี่ยวข้องร่วมฉลองความสำเร็จในงานพิธีประกาศผลประกวดรางวัล Adman Awards 2019</span>
            <span class="location">สามย่านมิตรทาวน์ฮอลล์ ชั้น5 ศูนย์การค้าสามย่านมิตรทาวน์</span>
            <!-- <p class="atc_node">“วันความคิดสร้างสรรค์แห่งชาติ 2019”

            </p>
            <p class="atc_node">ช่วงเช้าถึงเย็น รูปแบบงานคืองาน Talks, School of Creativity &amp; Exhibition ซึ่งเป็นงานของคนไทยทุกคน ที่เห็นคุณค่าของความคิดสร้างสรรค์</p>
            <p class="atc_node">งานของคนที่ชอบอวด(ดี) อวดไอเดียดีๆ อวดความคิดดีๆ ที่มาจากผู้คนหลากวงการ ทั้งสายโฆษณาสายบันเทิง สายออกแบบหรือดีไซน์ หรือแม้กระทั่งสายประชาชนคนธรรมดา </p>
            <p class="atc_node">แต่ไอเดียกระฉูดพร้อมฉุดธุรกิจ หรือองค์กร หรือชุมชนของพวกเขาให้โดดเด่นเป็นที่ยอมรับ งานที่ไม่ว่าคุณจะเป็นใคร ทำอาชีพอะไร </p>
            <p class="atc_node">อยู่ในวงการไหน หากเชื่อในพลังของความคิดสร้างสรรค์ นี่คือวันที่คุณจะค้นพบแรงบันดาลใจ และงานที่จะจุดประกาย ความคิดสร้างสรรค์ให้คุณอีกครั้ง </p>
            <p class="atc_node">
              และช่วงค่ำจะมีกิจกรรมพิเศษของคนในวงการโฆษณาและผู้มีส่วนเกี่ยวข้องร่วมฉลองความสำเร็จในงานพิธีประกาศผลประกวดรางวัล
              Adman Awards 2019
            </p> -->
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  data () {
    return {
      isCalendar: false,
      menus: [
        {
          title: 'Home',
          route: {
            name: 'home'
          }
        },
        {
          title: 'About',
          route: {
            name: 'about'
          }
        },
        {
          title: 'Creativity Day',
          route: {
            name: 'creativity'
          },
          active: false
        },
        // {
        //   title: 'Awards',
        //   route: {
        //     name: 'awards'
        //   }
        // },
        {
          title: 'News',
          route: {
            name: 'news'
          },
          active: false
        },
        {
          title: 'Winners',
          route: {
            name: 'winners'
          },
          active: false
        },
        {
          title: 'Archives',
          route: {
            name: 'archive'
          },
          subs: [
            {
              title: 'Winner Archive',
              // routeName: 'winnerArchive'
              routeName: 'archive'
            },
            {
              title: 'Program Archive',
              routeName: 'programArchive'
            }
          ],
          active: false
        },
        {
          title: 'Gallery',
          route: {
            name: 'gallery'
          },
          active: false
        },
        {
          title: 'Contact',
          route: {
            name: 'contact'
          },
          active: false
        }
      ],
      routeName: '',
      styleNavLg: {
        padding: '0',
        height: '0'
      },
      showSubArchives: false
    }
  },

  methods: {
    manualActive (index, cond) {
      this.menus.forEach((menu, i) => {
        if (i === index) {
          menu.active = cond
        }
      })
    },

    checkRouuteName () {
      this.routeName = this.$route.name
    },

    showNav () {
      this.styleNavLg.padding = '16px'
      this.styleNavLg.height = '100vh'
    },

    closeNav () {
      this.styleNavLg.padding = '0'
      this.styleNavLg.height = '0'
    },

    clickLogin () {
      window.open('https://admanawards.com/online_submission/index.php')
    },

    changeActive () {
      if (this.$route.name === 'creativity_program' ||
          this.$route.name === 'creativity_talk_symposium' ||
          this.$route.name === 'creativity_talk_symposium_detail' ||
          this.$route.name === 'creativity_school_of_creativity' ||
          this.$route.name === 'creativity_school_of_creativity_time' ||
          this.$route.name === 'creativity_school_of_creativity_detail'
      ) {
        this.manualActive(2, true)
      } else {
        this.manualActive(2, false)
      }

      if (this.$route.name === 'category-detail') {
        this.manualActive(3, true)
      } else {
        this.manualActive(3, false)
      }

      if (this.$route.name === 'news-detail') {
        this.manualActive(4, true)
      } else {
        this.manualActive(4, false)
      }

      if (this.$route.name === 'winners') {
        this.manualActive(5, true)
      } else {
        this.manualActive(5, false)
      }

      if (this.$route.name === 'winnerArchive' ||
          this.$route.name === 'winnerArchiveCategory' ||
          this.$route.name === 'winnerArchiveDetail' ||
          this.$route.name === 'programArchive' ||
          this.$route.name === 'programArchiveCategory' ||
          this.$route.name === 'programArchiveDetail') {
        this.manualActive(5, true)
      } else {
        this.manualActive(5, false)
      }

      this.checkRouuteName()
      this.closeNav()
    }
  },

  created () {
    console.log(this.$route.name)
    this.changeActive()

    if (this.$route.name === '_calendar') {
      this.isCalendar = true
    }
  },

  watch: {
    '$route' () {
      this.changeActive()

      // DEMO //
      if (this.$route.name === '_calendar') {
        this.isCalendar = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables.scss';

header {
  .s {
    .menu-btn-s {
      position: fixed;
      z-index: 20;
      right: 0;
      margin: 8px;
      width: 55px;
      height: 55px;
      border: none;
      background-image: url('../../assets/icons/bars-solid.svg');
      background-repeat: no-repeat;
      background-position: center;
      background-size: 50%;
      background-color: $active;
    }

    .overlay {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 20;
      padding: 0;
      height: 0;
      width: 100vw;
      background-color: black;
      overflow-x: hidden;
      transition: 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);

      .box-btn {
        display: flex;
        justify-content: space-between;
        align-items: center;

        img {
          width: auto;
          height: 42px;
        }

        .close-btn {
          width: 22px;
          height: 22px;
          border: none;
          background-image: url('../../assets/icons/times-solid.svg');
          background-repeat: no-repeat;
          background-position: center;
          background-color: black;
        }
      }

      .box-link {
        margin-top: 8px;

        .section-link {
          padding-top: 12px;
          padding-bottom: 12px;
          width: 100%;
          height: 100%;
          border-bottom: 1px solid rgba(255, 255, 255, 0.3);
          text-align: center;
          font-size: 1.75rem;

          a,
          span {
            color: #808285;
          }

          .router-link-exact-active {
            color: $active;
          }
        }
      }
    }
  }

  .m {
    display: none;
  }
}

.sub-archive-small {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 0 !important;
  border-bottom: 0 !important;

  a {
    padding-top: 4px;
    padding-bottom: 4px;
  }
}

.sub-archive-small--open {
  padding-bottom: 8px;
  height: 100% !important;
}

@media only screen and (min-width: 768px) {
  header {
    .s {
      display: none;
    }

    .m {
      position: fixed;
      z-index: 20;
      display: block;
      width: 100vw;
      height: 55px;
      background-color: $light;

      .first {
        display: flex;
        justify-content: space-between;
        height: 100%;

        .left {
          display: flex;
          justify-content: space-between;
          height: 100%;

          .section {
            a,
            span {
              display: flex;
              justify-content: center;
              align-items: center;
              padding-left: 8px;
              padding-right: 8px;
              height: 100%;
              font-size: 1.5rem;
              color: #808285;
            }
          }

          .router-link-exact-active {
            padding-bottom: 3px;
            // padding: 7px 6px;
            border-top: 3px solid red;
          }
        }
      }

      .right {
        transform: translateY(-220px);
        position: absolute;
        top: 0;
        right: 0;
        margin-right: auto;
        padding: 0 12px;
        width: 120px;
        background-color: $active;
        animation: right 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.3s forwards;

        @media only screen and (min-width: 992px) {
          right: calc(50% - 465px);
        }

        @media only screen and (min-width: 1200px) {
          right: calc(50% - 550px);
        }

        .box-search {
          display: flex;
          justify-content: space-between;
          padding: 8px 0;
          border-bottom: 1px solid white;

          input {
            width: 72px;
            border: none;
            background: none;
            font-size: 1.25rem;
            color: white;
          }

          input::placeholder {
            font-size: 1.25rem;
            color: white;
          }

          button {
            background-image: url('../../assets/icons/search-solid.svg');
            background-repeat: no-repeat;
            background-position: center;
            background-color: $active;
          }
        }

        .box-icon {
          display: flex;
          justify-content: center;
          padding: 12px 0;
          border-bottom: 1px solid white;

          img {
            height: 42px;
          }
        }

        .user-btn {
          padding: 12px 0;

          button {
            padding: 8px 0;
            width: 100%;
            background: none;
            font-size: 1.25rem;
            color: white;
          }
        }
      }

      .box-calendar {
        width: 140px;

        .box-search {
          display: flex;
          justify-content: center;

          p {
            font-size: 1.25rem;
            color: white;
          }
        }

        .box-icon {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 6px 0;

          img {
            height: 72px;
          }

          p {
            font-size: 1.25rem;
            color: #FFC107;
          }
        }

        .add-calendar {
          width: 100%;
          height: 52px;
          background: none;
          box-shadow: none !important;

          div {
            position: relative;
            left: -44px;
            top: 4px;
            width: 120px;
            text-align: center;
            font-family: 'DB Helvethaica X 57 Cond';
            font-size: 1.5rem;
            color: white;
          }
        }

        .add-calendar:focus {
          outline: none;
        }
      }
    }
  }
}

.sub-archive-medium {
  position: absolute;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 6px 12px;
  background-color: $active;

  a {
    border-bottom: 1px solid #F1F2F2;
    padding-top: 4px;
    padding-bottom: 4px;
    color: #F1F2F2 !important;
  }

  a:last-child {
    border-bottom: 0;
  }
}

@keyframes right {
  0% {
    transform: translateY(-220px);
  }

  100% {
    transform: translateY(0);
  }
}
</style>
